'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cva } from 'class-variance-authority';
import { useMaybeRoomContext, useMediaDeviceSelect } from '@livekit/components-react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue, } from '@/components/ui/select';
import { cn } from '@/lib/utils';
const selectVariants = cva([
    'w-full rounded-full px-3 py-2 text-sm cursor-pointer',
    'disabled:not-allowed hover:bg-button-hover focus:bg-button-hover',
], {
    variants: {
        size: {
            default: 'w-[180px]',
            sm: 'w-auto',
        },
    },
    defaultVariants: {
        size: 'default',
    },
});
export function DeviceSelect(_a) {
    var { kind, track, requestPermissions, onMediaDeviceError } = _a, 
    // initialSelection,
    // onActiveDeviceChange,
    // onDeviceListChange,
    props = __rest(_a, ["kind", "track", "requestPermissions", "onMediaDeviceError"]);
    const size = props.size || 'default';
    const room = useMaybeRoomContext();
    const { devices, activeDeviceId, setActiveMediaDevice } = useMediaDeviceSelect({
        kind,
        room,
        track,
        requestPermissions,
        onError: onMediaDeviceError,
    });
    if (devices.length < 2) {
        return null;
    }
    return (_jsxs(Select, { value: activeDeviceId, onValueChange: setActiveMediaDevice, children: [_jsx(SelectTrigger, { className: cn(selectVariants({ size }), props.className), children: size !== 'sm' && (_jsx(SelectValue, { className: "font-mono text-sm", placeholder: `Select a ${kind}` })) }), _jsx(SelectContent, { children: devices.map((device) => (_jsx(SelectItem, { value: device.deviceId, className: "font-mono text-xs", children: device.label }, device.deviceId))) })] }));
}
